import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

import React, { useState } from 'react';
import { DateRangePicker, defaultInputRanges } from 'react-date-range';
import { CalendarIcon } from '@chakra-ui/icons';
import { Box, Flex, Text } from '@chakra-ui/layout';
import { addDays } from 'date-fns';
import moment from 'moment';

import themeStyles from '../theme/styles';
import Button from './Button';

const { textStyles: themeTextStyles, colors, form: { input: inputStyles } } = themeStyles;

const DateRange = ({
  textStyle,
  styles,
  children,
  start: startDate = addDays(new Date(), -90),
  end: endDate = new Date(),
  format = 'MMM DD, YYYY',
  onChange = () => {},
  ...props
}) => {
  const [open, setOpen] = useState(false);
  const [range, setRange] = useState({ startDate, endDate, color: 'orange' });
  // display ranges (temporary)
  const [ranges, setRanges] = useState([{ ...range }]);

  const dateLabel = (s, e) => [s, e].map(d => moment(d).format(format)).join(' - ');
  const [label, setLabel] = useState(dateLabel(startDate, endDate));

  const handleApply = () => {
    const [range1] = ranges;
    const { startDate, endDate } = range1;
    // notify user
    onChange({ start: startDate, end: endDate });
    setRange(range1);
    setLabel(dateLabel(startDate, endDate));
    setOpen(false);
  };

  const handleCancel = () => {
    // reset range
    setRanges([{ ...range }]);
    const { startDate, endDate } = range;
    setLabel(dateLabel(startDate, endDate));
    setOpen(false);
  };

  const handleChange = ({ range1 = {} } = {}) => {
    setRanges([range1]);
  };

  const textStyles = { ...themeTextStyles[textStyle], ...styles };
  return (
    <Box position="relative">
      <Flex
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        style={inputStyles}
        onClick={() => setOpen(!open)}
      >
        <Text m={0} mr="1em">{label}</Text>
        <CalendarIcon m={0} />
      </Flex>
      {open && (
        <Box
          boxShadow="md"
          position="absolute"
          style={{
            right: 0,
            top: '3em',
            zIndex: 10,
            border: '1px solid',
            borderColor: colors.grey5,
          }}
        >
          <DateRangePicker
            ranges={ranges}
            onChange={handleChange}
            shownDate={range.endDate}
            maxDate={new Date()}
            inputRanges={[defaultInputRanges[0]]}
            editableDateInputs
            {...textStyles}
            {...props}
          >
            {children}
          </DateRangePicker>
          <Flex
            direction="row"
            justifyContent="center"
            alignItems="center"
            style={{
              backgroundColor: 'white',
              borderTop: '1px solid',
              borderColor: colors.grey300,
            }}
          >
            <Button textStyle="buttonLight" m={1} mr="2em" w="160px" onClick={handleCancel}>Cancel</Button>
            <Button m={1} w="160px" onClick={handleApply}>Apply</Button>
          </Flex>
        </Box>
      )}
    </Box>
  );
};

export default DateRange;
